export default __webpack_public_path__ + "static/IN-7011HD_Heater-Installation-c5ab5efb03d1a55488ee399f3578865e.png";